import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { CommonService } from "../../../services/common.service";

@Component({
  selector: "app-airline-exclusion",
  templateUrl: "./airline-exclusion.component.html"
})
export class AirlineExclusionComponent implements OnInit {
  viewTitle: string = "Airline Exclusion Master";
  updateApprove = false;
  rejected = 0;
  approveStatus;
  isApproved = false;
  insertDataTitle: string = "Airline Exclusion Master";
  loader: any = false;
  searchlist: boolean = true;
  showList: boolean = false;
  aprvbtn = false;
  searchresult: boolean = false;
  minRemark = false;
  nameExist = false;
  submitCountryArray: any = [];
  tags: boolean = false;
  countryArray: any = [];
  countryArray1: any = [];
  lcountryArray: any = [];
  checkedCountry: any = [];
  leftcheckedCountry: any = [];
  leftcountryArray: any = [];
  getdataArray: any = [];
  offSubmit = false;

  screentitle: string = "Airline Exclusion Master";
  actionmode: string = "Seacrh";
  exclusionParent_table = "mst_airline_exclusion";

  SUPPLIER_ID = "SUPPLIER_ID";
  SUPPLIER_NAME = "SUPPLIER_NAME";
  AIRLINE_ID = "AIRLINE_ID";
  AIRLINE_NAME = "AIRLINE_NAME";
  AIRLINE_CODE = "AIRLINE_CODE";
  childtables = ["UB_CNF_SUPPLIER"];
  childtables1 = "UB_CNF_SUPPLIER";
  combo_details1: any = [];
  filters = [];
  exclusionParent_table_ID = "SUPPLIER_ID";
  parent_table_ID1 = "SUPPLIER_ID";
  exclusionParent_result_ID = "";
  search_details: any = [];
  p: number = 1;

  dbFields = [
    this.SUPPLIER_ID,
    this.SUPPLIER_NAME,
    this.AIRLINE_ID,
    this.AIRLINE_NAME,
    this.AIRLINE_CODE
  ];

  searchitem = " ";
  searchColumn = " ";
  screen_details: any = [];
  serachtabledata: any = [];
  serachTableInfo: any = [];
  suppliers: any = [];
  data: any = [];
  status: any = {};
  exclusionSortType = "";
  exclusionAPPROVAL_STATUS = "APPROVAL_STATUS";
  exclusionAPPROVAL_REMARKS = "APPROVAL_REMARKS";
  exclusionAPPROVAL_BY = "APPROVAL_BY";
  exclusionApprove_details: any = [];
  exclusionUID = "";
  exclusionaprovebtn: boolean = true;
  exclusionrejectbtn: boolean = true;
  exclusionroleID = "";
  exclusionfid = "";
  exclusionRAC_VIEW = "";
  exclusionRAC_ADD = "";
  exclusionRAC_EDIT = "";
  exclusionRAC_APROVE = "";
  // count1 = 0;
  // count2 = 0;
  // count3 = 0;
  constructor(
    private vernostService: VernostServiceService,
    private commonService : CommonService
    ) {}

  ngOnInit() {
    this.exclusionUID = localStorage.getItem("uid");
    this.exclusionroleID = localStorage.getItem("roleID");
    this.exclusionfid = localStorage.getItem("fid");
    // alert("fid"+this.fid);

    var rollArray = {
      funId: this.exclusionfid,
      roleID: this.exclusionroleID
    };

    this.vernostService.checkFunAccess(rollArray).subscribe(response => {
      this.exclusionRAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.exclusionRAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.exclusionRAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.exclusionRAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    this.screen_details = {
      SUPPLIER_ID: "",
      SUPPLIER_NAME: ""
    };

    this.search_details = {
      SUPPLIER_ID: ""
    };
    this.exclusionApprove_details = {
      APPROVAL_REMARKS: ""
    };
    this.showList = false;
    // this.getSupplier();

    this.getAirlinesDataOnInit();
  }

  getAirlinesDataOnInit() {
    var data = {
      flag: "no"
    };
    this.vernostService.getAirlines(data).subscribe(response => {
      this.countryArray = response[0].addinfo;

      this.getctry(data, "no");
    });
  }

  getctry(tag, like) {
    var data = {
      flag: tag,
      like: like
    };
    this.vernostService.getAirlines(data).subscribe(response => {
      if (tag == "yes") {
        this.tags = true;
      }
      this.lcountryArray = response[0].addinfo;
    });
  }

  checkCountry(event, id, flag) {
    if (flag == "1") {
      if (event.target.checked) {
        this.checkedCountry.push(id);
      } else {
        for (let i = 0; i < this.checkedCountry.length; i++) {
          if (id == this.checkedCountry[i]) {
            this.checkedCountry.splice(i, 1);
          }
        }
      }
    } else {
      this.checkedCountry.push(id);
    }
  }

  leftCheckCountry(event, id) {
    if (event.target.checked) {
      this.leftcheckedCountry.push(id);
    } else {
      for (let i = 0; i < this.leftcheckedCountry.length; i++) {
        if (id == this.leftcheckedCountry[i]) {
          this.leftcheckedCountry.splice(i, 1);
        }
      }
    }
  }

  rightTransfer() {
    for (let m = 0; m < this.checkedCountry.length; m++) {
      for (let k = 0; k < this.countryArray.length; k++) {
        if (this.checkedCountry[m] == this.countryArray[k].AIRLINE_ID) {
          this.leftcountryArray.push(this.countryArray[k]);

          this.countryArray.splice(k, 1);
        }
      }
    }
    this.checkedCountry = [];
  }

  changeState() {
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.gotochangestatus();
    }
  }

  leftTransfer() {
    for (let m = 0; m < this.leftcheckedCountry.length; m++) {
      for (let k = 0; k < this.lcountryArray.length; k++) {
        if (this.leftcheckedCountry[m] == this.lcountryArray[k].AIRLINE_ID) {
          this.countryArray.push(this.lcountryArray[k]);

          //this.leftcountryArray.splice(k, 1);jkp
          // this.leftcheckedCountry.splice(m, 1);
        }
      }
    }

    for (let j = 0; j < this.leftcheckedCountry.length; j++) {
      for (let i = 0; i < this.leftcountryArray.length; i++) {
        if (this.leftcountryArray[i].AIRLINE_ID == this.leftcheckedCountry[j]) {
          this.leftcountryArray.splice(i, 1);
        }
      }
    }

    this.leftcheckedCountry = [];
  }

  addForm() {
    this.updateApprove = false;
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.screen_details = {
      SUPPLIER_ID: "",
      SUPPLIER_NAME: ""
    };
    this.search_details = {
      SUPPLIER_ID: ""
    };
    this.exclusionParent_result_ID = "";
    this.actionmode = "Add";
    this.showList = false;
    this.exclusionApprove_details = {
      APPROVAL_REMARKS: ""
    };
    this.getAirlinesDataOnInit();
    this.leftcountryArray = [];
  }

  searchForm() {
    this.updateApprove = false;
    this.searchresult = false;
    this.getAirlinesDataOnInit();
    this.checkedCountry = [];
    this.leftcountryArray = [];
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.screen_details = {
      SUPPLIER_ID: "",
      SUPPLIER_NAME: ""
    };
    this.search_details = {
      SUPPLIER_ID: ""
    };
    this.nameExist = false;
    this.actionmode = "Search";
    this.exclusionaprovebtn = true;
    this.exclusionrejectbtn = true;
  }
  checkAproval() {
    // this.exclusionaprovebtn="";
    var dbField = [this.exclusionAPPROVAL_STATUS];
    let arrayAirlineExclusion = {
      dbField: dbField,
      parent_table: this.exclusionParent_table,
      parent_table_ID: this.exclusionParent_table_ID,
      formdataId: this.exclusionParent_result_ID
    };
    this.vernostService.checkAproval(arrayAirlineExclusion).subscribe(response => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.exclusionaprovebtn = false;
        this.exclusionrejectbtn = true;
      }
      if (stat == 2) {
        this.exclusionrejectbtn = false;
        this.exclusionaprovebtn = true;
      } else {
        this.exclusionaprovebtn = true;
        this.exclusionrejectbtn = true;
      }
    });
  }
  gotochangestatus() {
    if (this.actionmode == "Edit") {
      var data = {
        parent_table: this.exclusionParent_table,
        formData: this.exclusionParent_result_ID,
        columnName: this.exclusionParent_table_ID
      };

      this.vernostService.editstatus(data).subscribe(response => {
        //   alert(response);
        this.isApproved = false;
      });
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    var dataAirlineExclusion = {
      parent_table: this.exclusionParent_table,
      formData: id,
      columnName: "SUPPLIER_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataAirlineExclusion).subscribe(res => {
      this.searchData();
    });
  } */

  changeName() {
    // alert(this.Parent_result_ID);
    var data = {
      parent_table: this.exclusionParent_table,
      formData: this.exclusionParent_result_ID,
      columnName: "SUPPLIER_ID"
    };

    this.vernostService.getSTATUS(data).subscribe(response => {
      // this.approveStatus = 0;
      // this.searchData

      this.approveStatus = response[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }
  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'airline-exclusion');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();

    var dbFieldAirlineExclusion = [
      this.exclusionAPPROVAL_STATUS,
      this.exclusionAPPROVAL_REMARKS,
      this.exclusionAPPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataAirlineExclusion = [
      status,
      this.exclusionApprove_details.APPROVAL_REMARKS,
      this.exclusionUID,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldAirlineExclusion,
      parent_table: this.exclusionParent_table,
      formData: formDataAirlineExclusion,
      parent_table_ID: " SUPPLIER_ID",

      formdataId: this.exclusionParent_result_ID
    };

    this.vernostService.aproveReject(array).subscribe(response => {
      this.exclusionApprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        this.rejected = 2;
        // this.searchForm();
        //this.searchData();
      } else {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }

        if (response[0].aproval == "aproved") {
          this.aprvbtn = false;
          // this.exclusionaprovebtn=false;
          //  alert(JSON.stringify(response[0].status));
          //  this.searchForm();
        }
        this.aprvbtn = false;
      }

      if (this.actionmode == "Edit") {
        this.submitdata();
      }
      this.searchresult = false;
      // this.searchForm();
    });
  }

  setId(id) {
    this.exclusionParent_result_ID = id;
  }


  /*
  sortByOrder(data, number_exclusion) {
    if (number_exclusion == 1) {
      if (this.count1 % 2 == 0) {
        this.exclusionSortType = "ASC";
      } else {
        this.exclusionSortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
      this.count3 = 0;
    }
    if (number_exclusion == 2) {
      if (this.count2 % 2 == 0) {
        this.exclusionSortType = "ASC";
      } else {
        this.exclusionSortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
      this.count3 = 0;
    }
    if (number_exclusion == 3) {
      if (this.count3 % 2 == 0) {
        this.exclusionSortType = "ASC";
      } else {
        this.exclusionSortType = "DESC";
      }
      this.count3++;
      this.count1 = 0;
      this.count2 = 0;
    }
    var arrayAirlineExclusion = {
      sortField: data,
      parent_table: this.exclusionParent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.exclusionSortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayAirlineExclusion).subscribe(resp => {
      this.serachtabledata = resp;
    });
  } */

  submitData1() {
    if (
      this.screen_details.SUPPLIER_ID == "" ||
      this.leftcountryArray.length <= 0
    ) {
      document.getElementById("errs").innerHTML = "Please fill all data";
    } else {
      if (this.actionmode != "Edit") {
        this.offSubmit = true;
        this.checkNames();
      } else {
        this.submitdata();
      }
    }
  }

  checkNames() {
    if (
      this.screen_details.SUPPLIER_ID != "" &&
      this.screen_details.SUPPLIER_ID != undefined
    ) {
      if (this.actionmode != "Edit") {
        var array = {
          columnName: "SUPPLIER_ID",
          dbFieldName: this.screen_details.SUPPLIER_ID,
          parent_table: this.exclusionParent_table
        };
        this.vernostService.checkName(array).subscribe(data => {
          if (data[0].status == "Sucess") {
            this.nameExist = false;
            if (this.offSubmit) {
              this.submitdata();
            }
          } else {
            this.nameExist = true;
          }
        });
      }
    }
  }

  // getSupplier() {
  //   this.vernostService.getSupplierInfo().subscribe(response => {
  //     this.suppliers = response;
  //     // alert(JSON.stringify(response));
  //   });
  // }
  onSelectedId() {
    var id = this.screen_details.SUPPLIER_ID;

    var array = {
      childtable: this.childtables1
    };
    this.vernostService.getComboData(array).subscribe(response => {
      if (response[0].status == this.childtables[0]) {
        this.combo_details1 = response[0].result;
        for (var i = 0; i < response.length; i++) {
          for (var j = 0; j < response[i].result.length; j++) {
            if (response[i].result[j].SUPPLIER_ID == id) {
              this.screen_details.SUPPLIER_NAME =
                response[i].result[j].SUPPLIER_NAME;
              // break;
            }
          }
        }
      }
    });
  }

  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }
    this.getAirlinesDataOnInit();
    this.checkedCountry = [];
    this.exclusionParent_result_ID = formData;

    var array = {
      formData: formData
    };
    //alert("formData" + formData);
    this.vernostService.getDataAirlinEx(array).subscribe(response => {
      this.approveStatus = response[0].result[0].STATUS;
      this.serachTableInfo = response[0].result;

      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
      if (this.actionmode == "Edit") {
        this.checkedCountry = [];
        this.leftcountryArray = [];
        for (let i = 0; i < response[0].result.length; i++) {
          this.checkedCountry.push(response[0].result[i].AIRLINE_ID);
        }
        this.rightTransfer();

        this.screen_details.SUPPLIER_ID = response[0].result[0].SUPPLIER_ID;
      }
    });

    if (toggle == "0") {
      this.showList = false;
      this.actionmode = "Edit";
    }

    if (toggle == "1") {
      this.showList = true;
      this.actionmode = "View";
    }
    if (toggle == "3") {
      this.showList = false;
      this.actionmode = "View";
    }

    //});
  }

  submitdata() {
    // alert("" + this.Parent_result_ID);
    this.submitCountryArray = [];

    var supplierId = this.screen_details.SUPPLIER_ID;

    if (supplierId == "" || this.leftcountryArray.length <= 0) {
      document.getElementById("errs").innerHTML = "Please fill all data";
      //alert("blocked");
    } else {
      for (let i = 0; i < this.leftcountryArray.length; i++) {
        this.submitCountryArray.push({
          id: this.leftcountryArray[i].AIRLINE_ID,
          name: this.leftcountryArray[i].AIRLINE_NAME,
          code: this.leftcountryArray[i].AIRLINE_CODE
        });
      }
      if (this.exclusionParent_result_ID == "") {
        document.getElementById("errs").innerHTML = "";

        if (this.exclusionParent_result_ID == "") {
          var Data = {
            sid: this.screen_details.SUPPLIER_ID,
            sname: this.screen_details.SUPPLIER_NAME,
            airline: this.submitCountryArray
          };

          this.vernostService.insertAirlineData(Data).subscribe(response => {
            //alert(response);

            document.getElementById("errs").innerHTML =
              "Record Created Successfully";
            setTimeout(() => {
              document.getElementById("errs").innerHTML = "";
              document.getElementById("errs").style.background = "#ebccd1";
              document.getElementById("errs").style.color = "#a94442";
            }, 1000);

            this.showFormData(this.screen_details.SUPPLIER_ID, 3, 1, 1);
          });
        }
      }
      // if (this.Parent_result_ID != "") {
      //   var Data1 = {
      //     sid: this.screen_details.SUPPLIER_ID,

      //     airline: this.submitCountryArray
      //   };

      //   this.vernostService.editAirlineData(Data1).subscribe(response => {
      //     this.searchForm();
      //     document.getElementById("errs").innerHTML =
      //       "Record Updated Successfully";
      //     setTimeout(() => {
      //       document.getElementById("errs").innerHTML = "";
      //       document.getElementById("errs").style.background = "#ebccd1";
      //       document.getElementById("errs").style.color = "#a94442";
      //     }, 1000);
      //   });
      // }
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.exclusionApprove_details.APPROVAL_REMARKS = "";
  }
  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.SUPPLIER_ID;

    if (field1 == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "") {
        searchitem.push(field1);
        searchColumn.push("SUPPLIER_ID");
      }

      var Data = {
        parent_table: this.exclusionParent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: [],
        filters: []
      };
     
      this.vernostService.searchRecord(Data).subscribe(responseRecord => {
        if (responseRecord.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = responseRecord;
          this.searchresult = true;
        }
         else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function() {document.getElementById("errs").innerHTML = "";}, 5000);
        }
      });
    }
  }
}
